function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

function splitTeeAddonTitle(title) {
  if (!title) return { name: '', price: '' };

  const match = title.trim().match(/^(.*?)(\s+[+-][^\s].*)$/);

  if (!match) {
    return { name: title.trim(), price: '' };
  }

  return {
    name: match[1].trim(),
    price: match[2].trim()
  };
}

function findAddonChargeField(root = document) {
  const fields = Array.from((root || document).querySelectorAll('.tee-field'));

  const byHeading = fields.find((field) => {
    const heading = field.querySelector('.tee-field__heading span');
    return heading && heading.textContent.trim().toLowerCase() === 'extra hinzufügen';
  });

  if (byHeading) return byHeading;

  return document.querySelector('.tee-field.tee-addon-charge-field');
}

function enhanceTeeinblueAddonCards(root = document) {
  const addonField = findAddonChargeField(root);
  if (!addonField) return;

  addonField.classList.add('tee-addon-charge-field');

  addonField.querySelectorAll('.tee-clipart-label').forEach((label) => {
    const sourceTitle =
      label.getAttribute('data-addon-title') ||
      label.getAttribute('data-title') ||
      label.querySelector('.tee-clipart-thumbnail')?.getAttribute('alt') ||
      '';

    const { name, price } = splitTeeAddonTitle(sourceTitle);
    if (!name && !price) return;

    const existingCopy = label.querySelector('.tee-addon-copy');
    if (existingCopy) existingCopy.remove();

    const copy = document.createElement('span');
    copy.className = 'tee-addon-copy';

    if (name) {
      const nameNode = document.createElement('span');
      nameNode.className = 'tee-addon-copy__name';
      nameNode.textContent = name;
      copy.appendChild(nameNode);
    }

    if (price) {
      const priceNode = document.createElement('span');
      priceNode.className = 'tee-addon-copy__price';
      priceNode.textContent = price;
      copy.appendChild(priceNode);
    }

    label.appendChild(copy);
    label.setAttribute('data-addon-title', sourceTitle);
    label.removeAttribute('data-title');
    label.removeAttribute('title');
  });
}

function reserveTeeinblueAddonSpace(root = document) {
  const addonField = findAddonChargeField(root);
  if (!addonField) return;

  addonField.querySelectorAll('.tee-clipart-row').forEach((row) => {
    const rowTop = row.getBoundingClientRect().top;
    let maxBottom = 0;

    row.querySelectorAll('.tee-clipart-label').forEach((label) => {
      const rect = label.getBoundingClientRect();
      const bottom = rect.bottom - rowTop;
      if (bottom > maxBottom) maxBottom = bottom;
    });

    if (!maxBottom) return;

    const targetHeight = Math.ceil(maxBottom) + 16;
    row.style.setProperty('height', `${targetHeight}px`, 'important');
    row.style.setProperty('min-height', `${targetHeight}px`, 'important');
    row.style.setProperty('padding-bottom', '0px', 'important');
    row.style.setProperty('margin-bottom', '15px', 'important');

    const nextBlock = row.nextElementSibling;
    if (nextBlock) {
      nextBlock.style.setProperty('margin-top', '15px', 'important');
      nextBlock.style.setProperty('clear', 'both', 'important');
      nextBlock.style.setProperty('position', 'relative', 'important');
    }
  });
}

function applyAddonChargeImageOverrides() {
  const addonField = findAddonChargeField(document);
  if (!addonField) return;

  const configScript = document.querySelector('[id^="TeeAddonChargeImages-"]');
  if (!configScript) return;

  let config;
  try {
    config = JSON.parse(configScript.textContent);
  } catch (error) {
    return;
  }

  const images = Array.isArray(config?.images) ? config.images : [];
  if (!images.some(Boolean)) return;

  addonField.querySelectorAll('.tee-clipart-thumbnail').forEach((img, index) => {
    const replacement = images[index];
    if (!replacement) return;

    img.src = replacement;
    img.setAttribute('data-src', replacement);
    img.setAttribute('srcset', replacement);
  });
}

function applyAddonChargeBestsellerBadge() {
  const addonField = findAddonChargeField(document);
  if (!addonField) return;

  const configScript = document.querySelector('[id^="TeeAddonChargeImages-"]');
  if (!configScript) return;

  let config;
  try {
    config = JSON.parse(configScript.textContent);
  } catch (error) {
    return;
  }

  const bestsellerIndex = Number(config?.bestsellerIndex || 0);

  addonField.querySelectorAll('.tee-addon-badge').forEach((badge) => badge.remove());

  if (!Number.isInteger(bestsellerIndex) || bestsellerIndex < 1) return;

  const targetLabel = addonField.querySelectorAll('.tee-clipart-label')[bestsellerIndex - 1];
  if (!targetLabel) return;

  const badge = document.createElement('span');
  badge.className = 'tee-addon-badge';
  badge.textContent = 'BESTSELLER';
  targetLabel.appendChild(badge);
}

function cleanupNonAddonTeeinblueCards(root = document) {
  const addonField = findAddonChargeField(root);

  document.querySelectorAll('.tee-field').forEach((field) => {
    if (addonField && field === addonField) return;

    field.classList.remove('tee-addon-charge-field');

    field.querySelectorAll('.tee-addon-copy').forEach((copy) => copy.remove());
    field.querySelectorAll('.tee-clipart-label').forEach((label) => {
      label.removeAttribute('data-addon-title');
    });
    field.querySelectorAll('.tee-clipart-row').forEach((row) => {
      row.style.removeProperty('height');
      row.style.removeProperty('min-height');
      row.style.removeProperty('padding-bottom');
      row.style.removeProperty('margin-bottom');
    });
  });
}

function refreshAddonChargeEnhancements(root = document) {
  cleanupNonAddonTeeinblueCards(root);
  enhanceTeeinblueAddonCards(root);
  ensureAddonChargeLoader(root);
  reserveTeeinblueAddonSpace(root);
  applyAddonChargeImageOverrides();
  applyAddonChargeBestsellerBadge();
}

let addonChargeRefreshTimer = null;
let addonChargeRevealTimer = null;
let addonChargeRecoveryObserver = null;
let addonChargePhaseTimers = [];

function scheduleAddonChargeRefresh(delay = 0, root = document) {
  if (addonChargeRefreshTimer) clearTimeout(addonChargeRefreshTimer);
  addonChargeRefreshTimer = setTimeout(() => {
    addonChargeRefreshTimer = null;
    refreshAddonChargeEnhancements(root);
  }, delay);
}

function setAddonChargeRefreshing(isRefreshing) {
  const addonField = findAddonChargeField(document);
  if (!addonField) return;

  addonField.classList.toggle('is-refreshing', isRefreshing);
}

function ensureAddonChargeLoader(root = document) {
  const addonField = findAddonChargeField(root);
  if (!addonField) return;

  const inputWrapper = addonField.querySelector('.tee-field__input');
  if (!inputWrapper) return;

  if (inputWrapper.querySelector('.tee-addon-loading')) return;

  const loader = document.createElement('div');
  loader.className = 'tee-addon-loading';
  loader.innerHTML = '<div class="tee-addon-loading__bar"></div>';
  inputWrapper.appendChild(loader);
}

function addonChargeLooksUnstyled() {
  const addonField = findAddonChargeField(document);
  if (!addonField) return false;

  if (!addonField.classList.contains('tee-addon-charge-field')) return true;

  const row = addonField.querySelector('.tee-clipart-row');
  const label = addonField.querySelector('.tee-clipart-label');
  const image = addonField.querySelector('.tee-clipart-thumbnail');

  if (!row || !label || !image) return false;

  const labelHasCopy = !!label.querySelector('.tee-addon-copy');
  const rowStyle = window.getComputedStyle(row);
  const imageStyle = window.getComputedStyle(image);

  return (
    !labelHasCopy ||
    rowStyle.display !== 'grid' ||
    imageStyle.maxWidth === '60px' ||
    imageStyle.width === '60px'
  );
}

function scheduleAddonChargeRecovery(delay = 0) {
  scheduleAddonChargeRefresh(delay, document);
}

function scheduleAddonChargeRecoveryPhases(withLoader = false) {
  addonChargePhaseTimers.forEach((timer) => clearTimeout(timer));
  addonChargePhaseTimers = [];

  if (withLoader) setAddonChargeRefreshing(true);

  [20, 120, 260].forEach((delay, index) => {
    const timer = setTimeout(() => {
      refreshAddonChargeEnhancements(document);

      if (index === 2) {
        setAddonChargeRefreshing(false);
      }
    }, delay);

    addonChargePhaseTimers.push(timer);
  });
}

function setupAddonChargeRecoveryObserver() {
  const recoveryRoot =
    document.getElementById('tee-artwork-form') ||
    document.querySelector('.tee-campaign-form-wrapper') ||
    findAddonChargeField(document);
  if (!recoveryRoot) return false;

  if (addonChargeRecoveryObserver) {
    addonChargeRecoveryObserver.disconnect();
    addonChargeRecoveryObserver = null;
  }

  addonChargeRecoveryObserver = new MutationObserver((mutations) => {
    let shouldCheck = false;

    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        shouldCheck = true;
        break;
      }

      if (mutation.addedNodes.length || mutation.removedNodes.length) {
        shouldCheck = true;
        break;
      }
    }

    if (!shouldCheck) return;

    if (addonChargeLooksUnstyled()) {
      scheduleAddonChargeRecoveryPhases(false);
    }
  });

  addonChargeRecoveryObserver.observe(recoveryRoot, {
    childList: true,
    subtree: true,
    attributes: false
  });

  return true;
}

function scheduleAddonChargeReveal(delay = 0) {
  if (addonChargeRevealTimer) clearTimeout(addonChargeRevealTimer);
  addonChargeRevealTimer = setTimeout(() => {
    addonChargeRevealTimer = null;
    refreshAddonChargeEnhancements(document);
    setAddonChargeRefreshing(false);
  }, delay);
}

enhanceTeeinblueAddonCards();
reserveTeeinblueAddonSpace();
cleanupNonAddonTeeinblueCards();
applyAddonChargeImageOverrides();
applyAddonChargeBestsellerBadge();

window.addEventListener('load', () => refreshAddonChargeEnhancements(document));
window.addEventListener('resize', debounce(() => scheduleAddonChargeRefresh(80, document), 100));

function setupAddonChargeAtcObserver() {
  const addToCartButton = document.querySelector(
    '.tee-btn--atc, #teeAtcButton, .tee-btn-wrapper--atc .tee-btn, .tee-form-atc-wrapper button'
  );

  if (!addToCartButton) return false;

  const atcObserver = new MutationObserver(() => {
    scheduleAddonChargeRecoveryPhases(true);
  });

  atcObserver.observe(addToCartButton, {
    attributes: true,
    attributeFilter: ['class', 'disabled', 'style']
  });

  addToCartButton.addEventListener('click', () => {
    scheduleAddonChargeRecoveryPhases(true);
  });

  return true;
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return;

  const addToCartButton = target.closest(
    '.tee-btn--atc, #teeAtcButton, .tee-btn-wrapper--atc .tee-btn, .tee-form-atc-wrapper button'
  );

  if (!addToCartButton) return;

  scheduleAddonChargeRecoveryPhases(true);
});

refreshAddonChargeEnhancements(document);
setupAddonChargeRecoveryObserver();

if (!setupAddonChargeAtcObserver()) {
  let addonChargeAtcAttempts = 0;
  const addonChargeAtcTimer = setInterval(() => {
    addonChargeAtcAttempts += 1;
    refreshAddonChargeEnhancements(document);
    setupAddonChargeRecoveryObserver();

    if (setupAddonChargeAtcObserver() || addonChargeAtcAttempts >= 20) {
      clearInterval(addonChargeAtcTimer);
    }
  }, 500);
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return;
  const clickedRefreshTarget = target.closest(
    '.tee-campaign-form-wrapper .tee-clipart-label, .tee-campaign-form-wrapper .tee-checkbox-input, variant-radios input[type="radio"], variant-radios label'
  );

  if (!clickedRefreshTarget) return;

  scheduleAddonChargeRecoveryPhases(false);
});

document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return;

  if (
    target.closest('.tee-campaign-form-wrapper .tee-checkbox-input') ||
    target.closest('variant-radios')
  ) {
    scheduleAddonChargeRecoveryPhases(false);
  }
});

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this.updateOptions();
    this.updateOptionAvailability();
    this.updateOptions();
    this.updateMasterId();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionAvailability();
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateOptionAvailability() {
    const selects = Array.from(this.querySelectorAll('select'));
    if (selects.length) {
      this.updateSelectAvailability(selects);
      return;
    }

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    if (fieldsets.length) this.updateRadioAvailability(fieldsets);
  }

  updateSelectAvailability(selects) {
    const selections = Array.isArray(this.options) ? [...this.options] : [];

    selects.forEach((select, optionIndex) => {
      const options = Array.from(select.options);

      options.forEach((option) => {
        option.disabled = !this.isOptionValueAvailable(optionIndex, option.value, selections);
      });

      const selectedOption = options.find((option) => option.value === select.value);

      if (!selectedOption || selectedOption.disabled) {
        const fallbackOption = options.find((option) => !option.disabled);
        if (fallbackOption) {
          select.value = fallbackOption.value;
          selections[optionIndex] = fallbackOption.value;
        } else {
          selections[optionIndex] = null;
        }
      } else {
        selections[optionIndex] = select.value;
      }
    });

    this.options = selections;
  }

  updateRadioAvailability(fieldsets) {
    const selections = Array.isArray(this.options) ? [...this.options] : [];

    fieldsets.forEach((fieldset, optionIndex) => {
      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));

      inputs.forEach((input) => {
        input.disabled = !this.isOptionValueAvailable(optionIndex, input.value, selections);
      });

      const checkedInput = inputs.find((input) => input.checked && !input.disabled);

      if (checkedInput) {
        selections[optionIndex] = checkedInput.value;
        return;
      }

      const fallbackInput = inputs.find((input) => !input.disabled);

      if (fallbackInput) {
        fallbackInput.checked = true;
        selections[optionIndex] = fallbackInput.value;
      } else {
        inputs.forEach((input) => {
          input.checked = false;
        });
        selections[optionIndex] = null;
      }
    });

    this.options = selections;
  }

  isOptionValueAvailable(optionIndex, optionValue, selections) {
    return this.getVariantData().some((variant) => {
      if (!variant.available) return false;

      return variant.options.every((variantOption, variantIndex) => {
        if (variantIndex === optionIndex) return variantOption === optionValue;

        const selectedValue = selections[variantIndex];
        return !selectedValue || variantOption === selectedValue;
      });
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return checkedRadio ? checkedRadio.value : null;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
